
import { defineComponent, readonly } from "vue";
import Link from "./Link.vue";
import links from "./links";

export default defineComponent({
  name: "Navigation",
  components: {
    Link,
  },
  setup() {
    return {
      links: readonly(links),
    };
  },
});
